/**
 * Handles `sync:conflict:resolved` on every till (sync plan Phase 5): the till
 * that pushed the transaction clears its stuck local row, and any till that
 * caches the record re-reads it so its copy matches the server again.
 */
import { clearResolvedConflict } from '@/services/sync-queue.service';
import { refreshCachedCustomer } from '@/services/offline-customer.service';

/** Mirrors services/api/src/events/events.gateway.ts :: emitSyncConflictResolved. */
export interface SyncConflictResolvedPayload {
  conflict_id: string;
  entity_type: string;
  resolution: string;
  resolved_by: string;
  client_id?: string | null;
  entity_id?: string | null;
}

export async function handleConflictResolved(payload: SyncConflictResolvedPayload): Promise<void> {
  if (!payload || typeof payload.conflict_id !== 'string') return;
  if (payload.client_id) {
    await clearResolvedConflict(payload.client_id, {
      resolution: payload.resolution,
      entityId: payload.entity_id,
    });
  }
  if (payload.entity_type === 'CUSTOMER' && payload.entity_id) {
    await refreshCachedCustomer(payload.entity_id);
  }
}
